/**
 * Supabase Client Initialization
 * 
 * This file creates and exports a singleton Supabase client instance
 * that is used throughout the application for all Supabase operations.
 * 
 * Features:
 * - Auto token refresh
 * - Persistent sessions in localStorage
 * - Automatic session detection from URL (for email confirmations, etc.)
 */

import { createClient } from '@supabase/supabase-js';
import { config } from '../config';

// Initialize Supabase client with configuration
export const supabase = createClient(
  config.supabase.url,
  config.supabase.anonKey,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      storage: window.localStorage,
    },
  }
);

// Export typed client for better TypeScript support
export type SupabaseClient = typeof supabase;

// Helper to check if Supabase is properly configured
export const isSupabaseConfigured = (): boolean => {
  return !!(config.supabase.url && config.supabase.anonKey);
};

